// extracted by css-extract-rspack-plugin
export default {"media":"MediaZoomPopup_media__xLWEv"};